import { render } from "./LuxUpsell.vue?vue&type=template&id=02f01458&ts=true"
import script from "./LuxUpsell.vue?vue&type=script&lang=ts"
export * from "./LuxUpsell.vue?vue&type=script&lang=ts"

import exportComponent from "/codebuild/output/src4241219202/src/hackingclub-spa/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__